import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import {
  generateDateStringWithNumber,
  addSevenDays,
  formatRP,
  getDateToday,
} from "../../../../Utils/externalFunctions";
import useAxios from "../../../../Utils/useAxios";
import { getUser } from "../../../../Utils/externalFunctions";
import { timeToast } from "../../../../Constant";
import { toast } from "react-toastify";
import { convertRPInputToIntValue } from "../../../../Utils/otherFunctions";
import {
  getFillAllFieldError,
  getInputDateBeforeTodayError,
} from "../../../../Constant/Message";
import {
  DateInputField,
  InputField,
  SelectionField,
  TextAreaField,
} from "../../../../CommonElements";
import FormModal from "../../../../Layout/Components/FormModal";
import { createUMO } from "../services";
toast.configure();

function CreateUMOModal({ unitKerja, modal, toggle, refreshUMO, UMOList }) {
  const MAX_NILAI_UMO_PER_DAY = 10000000;

  const axiosInstance = useAxios();

  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formattedNilai, setFormattedNilai] = useState("0");
  const [formData, setFormData] = useState({
    diajukan_oleh: getUser(),
    id_unit_kerja: "",
    untuk_tanggal: "",
    nilai: "",
    keterangan: "",
    batas_akhir: "",
    kode_umo: generateDateStringWithNumber(),
  });

  const resetForm = () => {
    setFormData({
      diajukan_oleh: getUser(),
      id_unit_kerja: "",
      untuk_tanggal: "",
      nilai: "",
      keterangan: "",
      batas_akhir: "",
      kode_umo: generateDateStringWithNumber(),
    });
    setFormattedNilai("0");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "untuk_tanggal") {
      const selectedDate = new Date(value);
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (selectedDate < yesterday) {
        {
          toast.error(getInputDateBeforeTodayError(), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: timeToast,
          });
        }
        return;
      }
      const batas_akhir = addSevenDays(value, 14);
      setFormData((prevState) => ({
        ...prevState,
        untuk_tanggal: value,
        batas_akhir: batas_akhir,
      }));
    } else if (name === "nilai") {
      const numericValue = convertRPInputToIntValue(value);

      setFormData((prev) => ({
        ...prev,
        nilai: numericValue,
      }));

      setFormattedNilai(formatRP(numericValue));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    checkUnit();
  }, [unitKerja]);

  const checkUnit = () => {
    if (unitKerja.length === 1) {
      setFormData((prevState) => ({
        ...prevState,
        id_unit_kerja: unitKerja[0].nama_unit_kerja,
      }));
    }
  };

  const getTotalUMOUsedToday = () => {
    let totalUMOUsed = 0;
    UMOList.map((item) => {
      if (item.untuk_tanggal === getDateToday("original")) {
        totalUMOUsed += parseFloat(convertRPInputToIntValue(item.nilai));
      }
    });
    return totalUMOUsed;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.untuk_tanggal === "" ||
      formData.nilai === "" ||
      formData.keterangan === ""
    ) {
      toast.error(getFillAllFieldError(), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return;
    } else {
      try {
        setWaitingForSubmit(true);
        await createUMO(axiosInstance, formData).then((res) => {
          refreshUMO();
          toggle();
          resetForm();
          checkUnit();
        });
      } finally {
        setWaitingForSubmit(false);
      }
    }
  };

  return (
    <FormModal
      title={"Uang Muka Operasional"}
      isOpen={modal}
      toggle={toggle}
      footerButtons={
        <>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={waitingForSubmit}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </>
      }
    >
      <Form>
        <DateInputField
          state={formData}
          label={"Untuk Tanggal"}
          name={"untuk_tanggal"}
          onChange={handleChange}
          value={formData.untuk_tanggal}
        />
        <InputField
          state={formData}
          label={"Nilai"}
          name={"nilai"}
          onChange={handleChange}
          value={formattedNilai}
        />
        <TextAreaField
          state={formData}
          label={"Keperluan"}
          name={"keterangan"}
          onChange={handleChange}
          value={formData.keterangan}
        />
        {unitKerja.length !== 1 ? (
          <SelectionField
            state={formData}
            label={"DPSJ"}
            name={"id_unit_kerja"}
            placeholder={"-------"}
            onChange={handleChange}
            options={unitKerja}
            optionsName={"nama_unit_kerja"}
          />
        ) : null}
      </Form>
    </FormModal>
  );
}

export default CreateUMOModal;
